
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { RouteMixin } from '@/modules/common/mixins/route';

import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { BaseCard } from '@/modules/common/components/cards/BaseCard';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { NavBar, Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { namespace } from 'vuex-class';
import { ICustomer } from '@/types/models';

import {
  trackLoadWalletBuilderSelection,
  trackCreateWalletReceiveSuggestion,
  trackAdvancedWallet
} from './track-events';

const customerModule = namespace('CustomerModule');

@Component({
  components: {
    BackButton,
    NavBar,
    BaseCard,
    Heading,
    BaseText
  }
})
export default class WalletBuilderSelection extends mixins(RouteMixin) {
  private NebraskaColors = NebraskaColors;

  @customerModule.Getter('getCustomer')
  private customer!: ICustomer;

  created() {
    trackLoadWalletBuilderSelection();
  }

  private goToBuilderView() {
    trackCreateWalletReceiveSuggestion();

    this.$router.push({ name: 'suggestedPortfolioBuilder' });
  }

  private goToAdvancedBuilderView() {
    trackAdvancedWallet();

    this.$router.push({ name: 'wealthBuilderView' });
  }

  private back() {
    this.$router.push({ name: 'wealth' });
  }
}
